var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chart",staticStyle:{"width":"650px","height":"380px","border":"1px solid #c7c7c7","padding":"10px"}})}
var staticRenderFns = []

export { render, staticRenderFns }